import CircularProgress from "@material-ui/core/CircularProgress";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import * as React from "react";

interface Props {
  loading?: boolean;
}

class ProgressOverlay extends React.Component<Props & StyledComponentProps> {
  public render() {
    const { classes, loading } = this.props;
    return (
      <div className={classes && classes.container}>
        {this.props.children}
        {loading && (
          <div className={classes && classes.overlay}>
            <CircularProgress />
          </div>
        )}
      </div>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  container: {
    height: "100%",
    position: "relative",
    width: "100%",
  },
  overlay: {
    alignItems: "center",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 1000,
  },
});

export default withStyles(styles)(ProgressOverlay);



// WEBPACK FOOTER //
// ./src/components/ProgressOverlay.tsx